// For unavailable %, return '--' else return the APY number
export function formatPercentageDisplay(
	value: number | null,
	nullDisplay = '--',
	isApyApprox = false,
) {
	return value === null ? nullDisplay : `${isApyApprox ? '~' : ''}${value}%`;
}

export function formatPercentageApyDisplay(
	value: number | null,
	nullDisplay = '--',
	isApyApprox = false,
) {
	
	if (!value || value > 10) {
		return '--';
	}
	return value === null ? nullDisplay : `${isApyApprox ? '~' : '~'}${value}%`;
}
